export default __webpack_public_path__ + "static/media/order.78264d6f.png";